



























import {Component, Vue} from "vue-property-decorator";
import {UserRole} from "@/store";
import {menuItems} from "@/store/menuItems";
@Component({
    components: {}
})
export default class Menu extends Vue {
    menuItems : any[] = [];
    /**
     * created_at: null
     delete: "0"
     get: "0"
     page: "adres"
     patch: null
     post: "0"
     updated_at: null
     user_id: "11"
     user_permission_id: "113"
     */
    mounted(){
        //TISS
        this.menuItems  = menuItems;
        console.log("mounted menu",this.menuItems);
        if(this.$store.state.role == UserRole.LIMITED_ADMIN){
            let newMenuItems : any[] = [];
            this.menuItems.forEach((menuItem:any,key:number)=>{
                let newItems : any[] = [];
                menuItem.items.forEach((item : any)=>{
                    this.$store.state.user.permissions.forEach((permission : any)=>{
                        if(permission.get == "1" && permission.page == item.action){
                            newItems.push(item);
                            return;
                        }
                    })
                });
                if(newItems.length > 0){
                    newMenuItems.push({
                        action: menuItem.action,
                        title: menuItem.title,
                        active: menuItem.active,
                        items:newItems
                    })
                }
            })
            this.menuItems = newMenuItems;
        }
    }
};
